import { render, staticRenderFns } from "./wsLink.vue?vue&type=template&id=dec70504&scoped=true&"
import script from "./wsLink.vue?vue&type=script&lang=js&"
export * from "./wsLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec70504",
  null
  
)

export default component.exports